import { Component, OnDestroy, OnInit, } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { ReportingService } from '../reporting.service';

@AutoUnsubscribe()
@Component({
    selector: 'ReportToEmail',
    templateUrl: './confirm-report-to-email.component.html',
    styleUrls: ['./confirm-report-to-email.component.css']
})

export class ConfirmReportToEmailComponent implements OnDestroy, OnInit {



    // private snapshotToDelete: AutoRunSnapshot;

    // private _reportName: string;
    // private _autoRunDate: Date;

    // get reportName(): string {
    //     return this._reportName;
    // }

    // set reportName(value: string) {
    //     this._reportName = value;
    // }

    // get autoRunDate(): Date {
    //     return this._autoRunDate;
    // }

    // set autoRunDate(value: Date) {
    //     this._autoRunDate = value;
    // }

    isDistributebyEmail: boolean; // ONE-4387

    selectedRecipients: string;

    header = 'Report to Email';

    constructor(
        // private reportService: ReportingService,
        private dialogRef: MatDialogRef<ConfirmReportToEmailComponent>,
        private reportService: ReportingService,
    ) {

        // this.snapshotToDelete = reportService.autoRunSnapshot;

        // this.autoRunDate = this.snapshotToDelete.TimeStamp;
        // this.reportName = this.snapshotToDelete.ReportName;
    }

    ngOnInit() {

        this.isDistributebyEmail = this.reportService.isDistributebyEmail;



        if (this.reportService.isDistributebyEmail) {

            this.header = 'Distribute By Email';

        }

        this.selectedRecipients = '';


        if (this.reportService.distributeByEmailOption_StudentSelected) {
            this.selectedRecipients += 'Student, ';
        }
        if (this.reportService.distributeByEmailOption_PrimaryContactSelected) {
            this.selectedRecipients += ' Primary Contact, ';
        }
        if (this.reportService.distributeByEmailOption_AllElectronicContactsSelected) {
            this.selectedRecipients += ' All Electronic Contacts, ';
        }

        let temp = '';
        temp = this.selectedRecipients.substring(0, this.selectedRecipients.length - 2); // remove trailing ,
        this.selectedRecipients = temp;

            if (this.reportService.inDebugMode) {
                console.log(this.isDistributebyEmail);
                console.log(this.selectedRecipients);
            }

    }

    okClick() {

        // const snapshotId = this.snapshotToDelete.AutoRunReportSnapshots_ID;

        // this.reportService.deleteReportSnapshot(snapshotId).subscribe(res => {

        //     // todo: check that the delete was successful
        //     this.reportService.autoRunSnapshot = null;
        //     // this.ReportToEmailEvent.emit(true);

        //     // if (this.reportService.inDebugMode) {

        //     // }
        // });

        this.dialogRef.close(true);
    }

    cancelClick() {
        // this.ReportToEmailEvent.emit(false);
        this.dialogRef.close(false);
    }

    ngOnDestroy() {
    }

}